// 依查詢條件下載裁處資訊 zip（含 Excel、CSV）
// 只送一次請求：以 fetch 取得檔案後由前端存檔，下載完成才還原按鈕（呼叫端需先 e.preventDefault()）
const DownloadPenaltyFile = (this_, iniData) => {
  if ($(this_).hasClass("disabled")) return;

  let isPenaltyDetailPage = $(this_).children("div").hasClass("title");
  let params = new URLSearchParams();
  for (let key in iniData) {
    if (iniData[key] !== "" && iniData[key] !== null && iniData[key] !== undefined) {
      params.append(key, iniData[key]);
    }
  }

  // 下載完成後還原按鈕原本的文字
  let originalText = $(this_).data("originalText") || $(this_).text();
  $(this_).data("originalText", originalText);
  $(this_).addClass("disabled");
  if (!isPenaltyDetailPage) {
    $(this_).text("資料下載中...");
  }

  fetch(`${host}api/v1/Penalty/PenaltyFile?${params.toString()}`)
    .then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.blob();
    })
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `裁處資訊-${moment().format("YYYYMMDDHHmmss")}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    })
    .catch(() => {
      $(".modal_notification .title").text("資料下載失敗，請稍後再試");
      $(".modal_notification").fadeIn().css("display", "flex");
      $("body").css("overflow", "hidden");
    })
    .finally(() => {
      $(this_).removeClass("disabled");
      if (!isPenaltyDetailPage) {
        $(this_).text(originalText);
      }
    });
};
